import type { Question, QuestionChoice } from '@mentimeter/http-clients';
import type { ChoicesResultT, TrendResultT } from '@mentimeter/visualizations';
import type { ChoicesVisualizationProps } from '../types';

export const trendsTestVotes = ({
  choices,
}: {
  choices: Question['choices'];
}): TrendResultT[] => {
  const NUMBER_OF_SESSIONS = 5;
  const sessions = [];

  for (let i = 0; i < NUMBER_OF_SESSIONS; i++) {
    const current = i === NUMBER_OF_SESSIONS - 1;
    const session = {
      id: i,
      label: current ? 'Current ' : `Session ${i + 1}`,
      current,
      data: {
        session: i,
        participantCount: 5,
        responses: choices.map((option, index) => ({
          id: index,
          title: option.label,
          responses: [Math.random() * 0.5 + (index + 5) * (Math.random() + 1)],
        })),
      },
    };
    sessions.push(session);
  }
  return sessions;
};

export const getChoicesTrends = (
  choices: QuestionChoice[],
  trendResults: TrendResultT[],
  hideResults: boolean,
): ChoicesVisualizationProps['results'] => {
  const emptyResults: ChoicesResultT[] = choices.map((c) => ({
    ...c,
    score: [0],
  }));

  return {
    previousRespondents: trendResults[0]?.data?.participantCount ?? 0,
    respondents: trendResults[1]?.data?.participantCount ?? 0,
    previousResults:
      trendResults[0]?.data?.responses && !hideResults
        ? trendResults[0].data.responses
        : emptyResults,
    results:
      trendResults[1]?.data?.responses && !hideResults
        ? trendResults[1].data.responses
        : emptyResults,
  } as ChoicesVisualizationProps['results'];
};
